// category — en. Canonical bazaar category display names.
// The KEY is the canonical English filter key stored in the database; the
// VALUE is what users read. Never translate the keys — products are matched
// against them.

export default {
  catHandmadeCrafts: 'Handmade Crafts',
  catFashion: 'Fashion',
  catFoodBeverage: 'Food & Beverage',
  catBeautyHealth: 'Beauty & Health',
  catHomeLiving: 'Home & Living',
  catSportsOutdoors: 'Sports & Outdoors',
  catBooksMedia: 'Books & Media',
  catServices: 'Services',

  // Subcategory display names
  subPotteryCeramics: 'Pottery & Ceramics',
  subWeavingTextiles: 'Weaving & Textiles',
  subJewelryAccessories: 'Jewelry & Accessories',
  subLeatherGoods: 'Leather Goods',
  subWoodwork: 'Woodwork',
  subHomeDecor: 'Home Décor',
  subWomensClothing: "Women's Clothing",
  subMensClothing: "Men's Clothing",
  subChildrensClothing: "Children's Clothing",
  subShoesBags: 'Shoes & Bags',
  subTraditionalClothing: 'Traditional Clothing',
  subAccessories: 'Accessories',
  subCoffeeTea: 'Coffee & Tea',
  subSpicesGrains: 'Spices & Grains',
  subHoneySweets: 'Honey & Sweets',
  subTraditionalFood: 'Traditional Food',
  subColdDrinks: 'Cold Drinks',
  subKitchenStaples: 'Kitchen Staples',
  subSkincare: 'Skincare',
  subHaircare: 'Haircare',
  subPerfumeFragrance: 'Perfume & Fragrance',
  subCosmetics: 'Cosmetics',
  subWellnessSupplements: 'Wellness & Supplements',
  subNaturalRemedies: 'Natural Remedies',
  subFurniture: 'Furniture',
  subKitchenDining: 'Kitchen & Dining',
  subBeddingLinens: 'Bedding & Linens',
  subLighting: 'Lighting',
  subStorage: 'Storage',
  subSportsEquipment: 'Sports Equipment',
  subFitnessExercise: 'Fitness & Exercise',
  subOutdoorCamping: 'Outdoor & Camping',
  subTeamSports: 'Team Sports',
  subCycling: 'Cycling',
  subAthleticWear: 'Athletic Wear',
  subBooksLiterature: 'Books & Literature',
  subStationeryJournals: 'Stationery & Journals',
  subMusicFilm: 'Music & Film',
  subArtCollectibles: 'Art & Collectibles',
  subMagazines: 'Magazines',
  subPhotography: 'Photography',
  subDesignPrinting: 'Design & Printing',
  subRepairMaintenance: 'Repair & Maintenance',
  subCleaning: 'Cleaning',
  subPersonalCare: 'Personal Care',
  subClassesTraining: 'Classes & Training',
};